<template>
    <Section class="test-design">
        <Card>
            <Loading v-if="showLoading" :absolute="false"/>
            <h1 class="header1">Big title with a gradient all long</h1>
            <h2 class="header2">A subtitle with a semi-long text</h2>
            <p>Body text lorem ipsum <b>dolores itea</b></p>
            <a href="#" class="inline">Inline link example</a>
            <footer>
                <PrimaryButton text="Primary button" @click="showHideLoading"/>
                <PrimaryButton text="Next" icon="s-icon-arrow-right"/>
            </footer>
        </Card>

        <Progress :progress="0.58"/>

        <footer>
            <PrimaryButton text="Previous" icon="s-icon-arrow-left" class="tertiary reverse" @click="showOrHideLoading"/>
            <PrimaryButton text="Next" icon="s-icon-arrow-right" class="tertiary"/>
        </footer>

        <PrimaryButton text="Primary button"/>
        <PrimaryButton text="Next" icon="s-icon-arrow-right"/>
        <PrimaryButton text="Primary button" class="big"/>
        <PrimaryButton text="Next" icon="s-icon-add" class="big"/>
        <PrimaryButton text="Primary button Secondary" class="big secondary"/>
        <PrimaryButton text="Primary button Tertiary" class="big tertiary"/>
        <PrimaryButton text="Primary button Red" class="big red"/>
        <PrimaryButton text="Primary button Green" class="big green"/>
        <PrimaryButton text="Next Reversed" icon="s-icon-arrow-left" class="tertiary reverse"/>


    </Section>
</template>

<script>
import Section from '@/components/v3/section/Section.vue'
import SectionHeader from '@/components/v3/section/SectionHeader.vue'
import Card from '@/components/v3/cards/Card.vue'
import PrimaryButton from '@/components/v3/buttons/PrimaryButton.vue'
import Progress from '@/components/v3/progress/Progress.vue'
import Loading from '@/components/v3/loading/Loading.vue'

export default {
    components: {
        Section,
        SectionHeader,
        Card,
        PrimaryButton,
        Progress,
        Loading
    },
    data() {
        return {
            showLoading: false
        }
    },
    methods: {
        showHideLoading() {
            this.showLoading = true
            setTimeout(() => {
                this.showLoading = false
            },
            500)
        },
        showOrHideLoading() {
            if (this.showLoading) {
                this.showLoading = false
            } else {
                this.showLoading = true
            }
        }
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.test-design

    .section-content > *
        margin-bottom 8px
</style>



// WEBPACK FOOTER //
// src/modules/_tests/components/TestDesign.vue